<div class="container" [class.only-suns]="onlySuns">
    @if (!onlySuns) {
        <div class="average-sun body-medium">
            <span>{{ 'PAGES.HISTORY.SUN_RADIANCE_MAX' | translate }}</span>
            <div class="average-sun-value">
                <web-fading-span
                    valueClass="number-regular"
                    [value]="averageValue"
                    [suffix]="'GLOBAL.W_PER_M_2' | translate"
                ></web-fading-span>
                <div class="suns">
                    @for (i of sunsPercent; track $index) {
                        <div class="sun" [class.size-50]="i === 50" [class.size-100]="i === 100"></div>
                    }
                </div>
            </div>
        </div>
    } @else {
        <span class="body-medium">{{ 'PAGES.HISTORY.SUN_RADIANCE' | translate }}</span>
        <div class="suns">
            @for (i of sunsPercent; track $index) {
                <div class="sun" [class.size-50]="i === 50" [class.size-100]="i === 100"></div>
            }
        </div>
    }
</div>
